
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Group, ListItem } from '../../backend/backendapi';
import { formatDateTime } from '../../../util';
import { applyGroupSelector, GroupSelector } from '../util';

@Component
export default class TabGeneral<T> extends Vue {
  @Prop({ required: true })
  readonly group!: T;
  @Prop({ required: true })
  readonly users!: ListItem[];
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  @Prop({ default: false })
  readonly hidePinned!: boolean;

  formatDateTime = formatDateTime;

  get extractedGroup(): Group {
    return applyGroupSelector(this.group, this.groupSelector);
  }

  get usersAndUnknownUser(): ListItem[] {
    return [...this.users, { id: '00000000-0000-0000-0000-000000000000', firstName: '(' + this.$t('general.unknown') + ')' } as ListItem];
  }

  get usersById(): Map<string, ListItem> {
    return new Map(this.usersAndUnknownUser.map(e => [e.id!, e]));
  }

  formatUserBaseName(userBase?: ListItem): string {
    return (userBase?.firstName ?? ' ') + ' ' + (userBase?.lastName ?? ' ');
  }
}
